module.exports = __webpack_public_path__ + "img/06.38d85d50.jpg";